import { Action, createReducer, on } from '@ngrx/store';
import {
  getReportFiltersAction, getReportFiltersSuccessAction, getReportFiltersFailureAction,
} from './get-report-filters.actions';
import { GetReportFiltersState } from './get-report-filters.types';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null,
};

const getReportFiltersReducer = createReducer<GetReportFiltersState>(
  initialState,
  on(
    getReportFiltersAction,
    state => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),
  on(
    getReportFiltersSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      data: action.data,
      error: null,
    })
  ),
  on(
    getReportFiltersFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetReportFiltersState, action: Action) => getReportFiltersReducer(state, action);
